import { useContext } from "react"
import { BlockContext } from "../context/block-context"
import { ActiveBlockContext } from "../context/active-block-context"
import { getBlockById } from "../utils/block-traversal"

/**
 * Allows you to retrieve and set the active block; that is, the block that is
 * shown in the sidebar. Example:
 *
 * ```js
 * const { activeBlock, setActiveBlockId } = useActiveBlock()
 *
 * console.log(activeBlock) // object containing the active block's data
 * setActiveBlockId(block_id) // pass in a block_id to focus a different block
 * ```
 */

export function useActiveBlock() {
  const {
    activeBlockId,
    setActiveBlockId,
    override,
    setOverride,
    overrideProps,
    setOverrideProps
  } = useContext(ActiveBlockContext)
  const { blocks } = useContext(BlockContext) || {}

  const activeBlock = getBlockById(activeBlockId, blocks)

  function handleSetActiveBlockId(id) {
    setActiveBlockId(id)
    setOverride(null)
  }

  function handleSetOverride(id) {
    setActiveBlockId(null)
    setOverride(id)
    setOverrideProps({})
  }

  return {
    activeBlock,
    setActiveBlockId: handleSetActiveBlockId,
    override,
    setOverride: handleSetOverride,
    overrideProps,
    setOverrideProps
  }
}
